import React from 'react';
import HostgroupJobs from './HostgroupJobs';

export default [
  {
    path: '/ansible/hostgroups/:id',
    render: props => <HostgroupJobs {...props} />,
    exact: true,
  },
];



// WEBPACK FOOTER //
// /builddir/build/BUILDROOT/rubygem-foreman_ansible-9.0.1-1.fm3_4.el8.noarch/usr/share/gems/gems/foreman_ansible-9.0.1/webpack/routes/routes.js